import { useContext } from 'react';

import { CategoricalBarChartOverlayRefContext } from '../contexts/CategoricalBarChartOverlayRefContext.js';

export const useCategoricalBarChartOverlayRef = () => {
  const context = useContext(CategoricalBarChartOverlayRefContext);

  if (!context) {
    throw new Error(
      '"useCategoricalBarChartOverlayRef" needs to be used under "CategoricalBarChartOverlayRefContext"',
    );
  }

  return context;
};
